module.exports = __webpack_public_path__ + "img/apple-store-en-black.2928664f.svg";